import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import { sizeGuide } from '@/data/translatedData';
import { tx } from '@/translations/translations';

export const ProductSizeGuide = ({ product, language }) => {
  return (
    <>
          <TabsContent value="sizes" data-testid="size-guide-tab-content">
            {/* Adult Tank Top - only for Tank Top/Kol Haposkim/Talit products */}
            {product.style !== 'T-Shirt' && (
            <div className="mb-4">
              <h4 className="text-sm font-semibold text-slate-800 mb-2">{sizeGuide.adult.title[language] || sizeGuide.adult.title.en}</h4>
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-slate-100">
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Talla', 'Size', 'מידה')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Largo', 'Length', 'אורך')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Ancho', 'Width', 'רוחב')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sizeGuide.adult.sizes.map((row) => (
                      <tr key={`adult-${row.size}`} className={sizeGuide.adult.sizes.indexOf(row) % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                        <td className="px-2 py-1.5 font-medium text-slate-700 border border-slate-200">{row.size}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.largo}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.ancho}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            )}
            {/* Kids numbered - only for Tank Top products */}
            {product.style !== 'T-Shirt' && product.style !== 'Talit Gadol' && product.style !== 'Kol Haposkim' && (
            <div className="mb-4">
              <h4 className="text-sm font-semibold text-slate-800 mb-2">{sizeGuide.kids.title[language] || sizeGuide.kids.title.en}</h4>
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-slate-100">
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Talla', 'Size', 'מידה')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Edad', 'Age', 'גיל')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Pecho', 'Chest', 'חזה')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Largo', 'Length', 'אורך')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sizeGuide.kids.sizes.map((row) => (
                      <tr key={`kids-${row.size}`} className={sizeGuide.kids.sizes.indexOf(row) % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                        <td className="px-2 py-1.5 font-medium text-slate-700 border border-slate-200">{row.size}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.age[language] || row.age.en}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.chest}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.length}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            )}
            {/* Kids T-Shirt - only for T-Shirt products */}
            {product.style === 'T-Shirt' && (
            <div>
              <h4 className="text-sm font-semibold text-slate-800 mb-2">{sizeGuide.kidsLettered.title[language] || sizeGuide.kidsLettered.title.en}</h4>
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-slate-100">
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Talla', 'Size', 'מידה')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Edad', 'Age', 'גיל')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Pecho', 'Chest', 'חזה')}</th>
                      <th className="px-2 py-1.5 text-left font-semibold text-slate-600 border border-slate-200">{tx(language, 'Largo', 'Length', 'אורך')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sizeGuide.kidsLettered.sizes.map((row) => (
                      <tr key={`kidsL-${row.size}`} className={sizeGuide.kidsLettered.sizes.indexOf(row) % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                        <td className="px-2 py-1.5 font-medium text-slate-700 border border-slate-200">{row.size}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.age[language] || row.age.en}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.chest}</td>
                        <td className="px-2 py-1.5 text-slate-600 border border-slate-200">{row.length}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            )}
          </TabsContent>
    </>
  );
};
